<template>
  <div class="modal-content">
    <h1 class="text-center">{{$t('tasks.customDeleteTitle')}}</h1>
    <div class="columns">
      <div class="column is-12">
        <p class="text-center">{{$t('tasks.customDeleteText')}}</p>
      </div>
    </div>
    <div class="text-center buttons-modal">
      <a @click="handleRemoveTask()" class="button primary">{{$t('tasks.customDeleteOK')}}</a>
      <a @click="closeModal()" class="button">{{$t('global.cancel')}}</a>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'remove-task-modal',
  props: {
    data: {
      type: [Object, Array, String, Number, Boolean],
      required: false
    }
  },
  methods: {
    ...mapActions({
      removeCustomTask: 'removeCustomTask',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      setTaskDataChanged: 'setTaskDataChanged'
    }),
    closeModal () {
      this.setShowModal(false)
      this.setModalType(null)
      this.setModalData(null)
    },
    handleRemoveTask () {
      this.removeCustomTask(this.data)
      this.setTaskDataChanged()
      this.closeModal()
    }
  }
}
</script>

<style>

</style>
